import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { PropsWithChildren } from "react";

import { classes as fileUploaderClasses } from "../../FileUploader/FileUploader";

interface UploadBoxProps {
  selected?: boolean;
}

export const classes = {
  root: "Upload-root",
  uploadBox: "Upload-uploadBox",
};

const UploadBox = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "selected",
})<UploadBoxProps>(({ theme, selected }) => ({
  border: `1px solid ${theme.palette.secondary[5]}`,
  background: selected
    ? `repeating-conic-gradient(${theme.palette.secondary[8]} 0 25%, #0000 0 50%) 50% / 20px 20px`
    : "transparent",
  padding: "4px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: selected ? "flex-start" : "center",
  borderRadius: 8,

  ...(!selected && {
    width: "230px",
    height: "230px",
  }),

  [`.${fileUploaderClasses.container}`]: {
    height: "100%",
  },
}));

const UploadSection = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
  background: theme.palette.secondary["6/75"],
  borderBottom: `1px solid ${theme.palette.secondary[6]}`,
  padding: theme.spacing(1),
}));

export const Upload = (props: PropsWithChildren<UploadBoxProps>) => {
  const { selected, children } = props;

  return (
    <UploadSection className={classes.root}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <UploadBox selected={selected} className={classes.uploadBox}>
          {children}
        </UploadBox>
      </Box>
    </UploadSection>
  );
};
